const bookingReferencesStyle = {
  root: {
    flexGrow: 1,
  },
  valueSelector: {
    width: 750,
    maxWidth: 750,
  },
  createBtn: {
    marginTop: '10px',
  },
  fieldSpacing: {
    marginTop: '10px',
  },
  leftHeading: {
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
  table: {
    marginBottom: '150px',
    marginTop: '40px',
  },
  saveButton: {
    float: 'right',
    marginTop: '20px',
  },
}

export default bookingReferencesStyle
